import FootnoteCitation from '../../FootnoteCitation';
import { useMarkdownRendererContext } from '../MarkdownRenderer.context';

import type { DiffCitationType } from '../../FootnoteCitation';
import type { HTMLAttributes, ReactNode } from 'react';

type CustomSupProps = HTMLAttributes<HTMLElement> & {
  'data-footnote-number'?: string;
  'data-diff-citation'?: DiffCitationType;
};

const CustomSup = (props: CustomSupProps): ReactNode => {
  const footnoteNumber = props['data-footnote-number'];
  const diffCitation = props['data-diff-citation'];

  if (!footnoteNumber) {
    return <sup {...props} />;
  }

  return (
    <FootnoteCitationFromContext
      footnoteNumber={footnoteNumber}
      diffType={diffCitation}
    />
  );
};

const FootnoteCitationFromContext = ({
  footnoteNumber,
  diffType,
}: {
  footnoteNumber: string;
  diffType?: DiffCitationType;
}): ReactNode => {
  const { sources, diffSources, onRemoveSource, isRemoveSourceDisabled } =
    useMarkdownRendererContext();

  const num = parseInt(footnoteNumber, 10);
  // Deleted citations reference the old version's sources
  const effectiveSources =
    diffType === 'del' && diffSources ? diffSources : sources;
  const source = effectiveSources[num - 1];

  return (
    <FootnoteCitation
      number={num}
      sources={effectiveSources}
      onRemove={
        onRemoveSource && source ? () => onRemoveSource(source) : undefined
      }
      removeDisabled={isRemoveSourceDisabled}
      diffType={diffType}
      // diffSources is only set when the renderer shows a diff
      inDiff={diffSources !== undefined}
      // A swap keeps its number, so the old source sits at the same index
      replacedSource={diffType === 'swap' ? diffSources?.[num - 1] : undefined}
    />
  );
};

export default CustomSup;
